let _promise = null;
let _recordPromises = {};

export const prefetchUsers = (service) => {
  if (_promise) return;
  _promise = service.getUsersList();
};

export const consumePrefetch = () => {
  const p = _promise;
  _promise = null;
  return p;
};

export const prefetchUserRecord = (service, id) => {
  if (_recordPromises[id]) return;
  _recordPromises[id] = service.getUserRecord(id);
};

export const consumeUserRecordPrefetch = (id) => {
  const p = _recordPromises[id];
  delete _recordPromises[id];
  return p;
};
